<template>
  <div>
    <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab class="tab-default" :key="1"> Học sinh</v-tab>
    </v-tabs>

    <v-card class="mr-3" :flat="$vuetify.breakpoint.smAndDown">
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1">
          <StudentTable />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import StudentTable from './StudentTable.vue'
export default {
  components: { StudentTable },
  data() {
    return {
      tab: null
    }
  }
}
</script>
